"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class EventBusV {
    on(eventType, callback) {
        const id = Symbol('id');
        if (!EventBusV.subscriptions[eventType])
            EventBusV.subscriptions[eventType] = {};
        EventBusV.subscriptions[eventType][id] = callback;
        return {
            off: function unsubscribe() {
                delete EventBusV.subscriptions[eventType][id];
                if (Object.getOwnPropertySymbols(EventBusV.subscriptions[eventType])
                    .length === 0) {
                    delete EventBusV.subscriptions[eventType];
                }
            },
        };
    }
    emit(eventType, arg) {
        if (!EventBusV.subscriptions[eventType])
            return;
        Object.getOwnPropertySymbols(EventBusV.subscriptions[eventType]).forEach(key => EventBusV.subscriptions[eventType][key](arg));
    }
}
exports.EventBusV = EventBusV;
EventBusV.subscriptions = {};
exports.EventBus = new EventBusV();
//# sourceMappingURL=EventBusV.js.map